

import React, { memo, useState, useCallback, useEffect } from 'react';
import { formatDate, DATE_FORMAT } from '@shootsta/get-moment';
import { FormModal, Icon, Input, Row, Col, Text, RadioButton, List } from '../../../../ui-kit';

import './styles/_splash-link.scss';













const LinkSplashPage = (props) => {
  const {
    title,
    visible,
    onClose,
    templateId,
    existingSplashPage,
    setTemplateDetails,
    getSplashTemplatesByOrg,
    updatePitchSplashLink
  } = props;

  const [splashId, setSplashId] = useState(existingSplashPage);
  const [totalSplashPages, setTotalSplashPages] = useState(null);
  const [searchableSplashPages, setSearchableSplashPages] = useState(null);


  const getSplashPagesDetails = useCallback(async () => {
    const { data, error } = await getSplashTemplatesByOrg();
    if (!error) {
      setTotalSplashPages(data.getSplashTemplatesByOrg);
      setSearchableSplashPages(data.getSplashTemplatesByOrg);
    } else {
      setTotalSplashPages([]);
      setSearchableSplashPages([]);
    }
  }, [getSplashTemplatesByOrg]);

  useEffect(() => {
    getSplashPagesDetails();
  }, [getSplashPagesDetails]);

  const onSave = async () => {
    await updatePitchSplashLink({
      pitchTemplateId: templateId,
      splashTemplateId: splashId
    });
    setTemplateDetails();
    onClose();
  };

  const onSearchFilter = ({ target: { value } }) => {
    const splashTemplates = totalSplashPages && totalSplashPages.filter(
      ({ templateName }) => templateName.toLowerCase().includes(value.toLowerCase())
    );
    setSearchableSplashPages(splashTemplates);
  };

  return (
    <FormModal
      key="splash-link-modal"
      title={title}
      visible={visible}
      onClose={onClose}
      onSave={onSave}
      saveDisabled={!splashId}
      stayOpenOnSave
      saveText="Confirm & Save">

      {
      !searchableSplashPages ?
      <Icon name="shootstagrad" size={40} color="black" spin /> :

      <div className="splash-link-modal">
            <Row nogutter className="splash-link-modal__search">
              <Col sm={12} md={12}>
                <Text highlighted>Available Splash Pages</Text>
                <Input
              prefix="search"
              onChange={onSearchFilter}
              clearButton={<Icon name="close" size={10} color="regent" />}
              placeholder="Search splash pages" />

              </Col>
            </Row>
            {searchableSplashPages.length ?
        <div className="splash-link-modal__content">
                <div className="splash-link-modal__content__types">
                  {searchableSplashPages.map((splashPage) =>
            <>
                      {/* $FlowFixMe */}
                      <List.CardItem
                className="splash-link-modal__content__types__item"
                key={splashPage.splashTemplateId}
                onClick={() => setSplashId(splashPage.splashTemplateId)}>

                        <RadioButton
                  lightMode
                  selected={splashPage.splashTemplateId === splashId} />

                        <div>
                          <Text heading5 noMargin>{splashPage.templateName}</Text>
                          <Text noMargin>
                            {formatDate(
                      splashPage.createdAt,
                      DATE_FORMAT.MONTH_SHORT_DAY_YEAR
                    )}
                          </Text>
                        </div>
                      </List.CardItem>
                    </>
            )}
                </div>
              </div> :

        <Text>No result found</Text>}


          </div>}



    </FormModal>);

};

export default memo(LinkSplashPage);